import React from "react"
import {NO_FOLLOW} from "../../../../config/constants"
import Link from "../../../Link"
import {Li} from "./component"
import {removeDeptFromSessionStorage} from "../../../../utils/removeDeptFromSessionStorage"
import {buildGaTags} from "../../../../utils/dataGA"
import Icon from "../../../Icon"

export type StandardQuickLinkProps = {
    text: string | null
    icon: string | null
    url: string
    accessibilityText: string
}

export const StandardQuickLink = ({text, url, icon, accessibilityText}: StandardQuickLinkProps) => {
    return (
        <Li>
            {/* eslint-disable-next-line */}
            <div onClick={removeDeptFromSessionStorage} data-testid="quicklink-container">
                <Link href={url} rel={NO_FOLLOW} {...buildGaTags(text)}>
                    {text && <span>{text}</span>}
                    {icon && <Icon src={icon} alt={accessibilityText} />}
                </Link>
            </div>
        </Li>
    )
}

export default StandardQuickLink
